<script>
import nav_arrow_right from "./assets/nav_arrow_right.svg";
import nav_arrow_down from "./assets/nav_arrow_down.svg";

export default {
  name: "NavCell",
  props: {
    info: Object,
    child: Boolean,
    index: Number,
    ChildrIcon: Boolean,
    versionObj: Object,
    version: String
  },
  data() {
    const RoutePath = this.$route.fullPath;
    const isHideChildrIcon = this.ChildrIcon || false;
    let isChildSelect = false;
    if (this.info.children) {
      isChildSelect =
        this.info.children.filter(item => RoutePath.indexOf(item.path) > -1)
          .length > 0;
    } else {
      isChildSelect = RoutePath.indexOf(this.info.path) > -1;
    }
    console.log('__>', isChildSelect)
    return {
      nav_arrow_right,
      nav_arrow_down,
      curPath: "",
      isHideChildrIcon,
      isChildSelect,
      version_obj: {}
    };
  },
  watch: {
    versionObj: {
      deep: true,
      handler:function(newVal,oldVal) {
        this.$nextTick(() => {
          this.version_obj = newVal;
        })
      }
    }
  },
  computed: {
    pStyle() {
      if (this.child) {
        return {
          marginLeft: "60px"
        };
      }
    },
    isActive() {
      const RoutePath = this.$route.fullPath;
      return RoutePath.indexOf(this.info.path) > -1;
    }
  },
  methods: {
    click() {
      if (this.info.action) {
        this.info.action();
      }
    },
    change(val) {
      if (this.child) {
        this.$emit("clickChildren", this.info.path);
      }
      this.$emit("topNavClicked", val);
      this.$emit("modleNavClicked", val);
    },
    imgFilter(info) {
      const RoutePath = this.$route.fullPath;
      let isChildSelect = false;

      if (info.children) {
        isChildSelect =
          info.children.filter(item => RoutePath.indexOf(item.path) > -1)
            .length > 0;
      } else {
        isChildSelect = RoutePath.indexOf(info.path) > -1;
      }
      // if (info.showChildren !== undefined) {
      //   return info.showChildren ? info.iconColor : info.iconGray;
      // }
      return isChildSelect ? info.iconColor : info.iconGray;
    },
    imgFilters(info) {
      const RoutePath = this.$route.fullPath;
      let isChildSelect = false;

      if (info.children) {
        isChildSelect =
          info.children.filter(item => RoutePath.indexOf(item.path) > -1)
            .length > 0;
      } else {
        isChildSelect = RoutePath.indexOf(info.path) > -1;
      }
      // if (info.showChildren !== undefined) {
      //   return info.showChildren ? info.iconColor : info.iconGray;
      // }
      return isChildSelect ? info.iconColor : info.iconGray;
    },
    fontColorFilters(info) {
      const RoutePath = this.$route.fullPath;
      // if (info.showChildren !== undefined) {
      //   return info.showChildren ? info.iconColor : info.iconGray;
      // }
      return info.path === RoutePath;
    },
    clickChildren(val) {
      this.$emit("clickChildren", val);
    }
  }
};
</script>

<template>
  <div class="NavCell" @click="change(index)">
    <router-link
      v-if="info.path"
      tag="div"
      class="cell"
      :class="{cellSelected: isActive}"
      :to="{path:info.path}"
    >
      <img
        class="icon"
        :class="{galssLarge: ['双眼视功能训练', '视功能检测'].indexOf(info.name) > -1}"
        v-if="!child"
        :src="imgFilter(info)"
        alt
      />
      <p :style="pStyle">{{info.name}}</p>
      <img
        v-if="!isHideChildrIcon && info.children && info.children.length"
        :src="info.showChildren?nav_arrow_down:nav_arrow_right"
        class="arrow"
      />
    </router-link>
    <div v-else class="cell" :class="{cellShowChildren: isChildSelect}" @click="click">
      <img
        class="icon"
        :class="{galssLarge: ['双眼视功能训练', '视功能检测'].indexOf(info.name) > -1}"
        v-if="!child"
        :src="imgFilters(info)"
        alt
      />
      <p :style="pStyle">{{info.name}}<span class="versionBox" v-if="version_obj && version != version_obj.version && info.name == '关于软件'">更新</span></p>
      <img
        v-if="!isHideChildrIcon && info.children && info.children.length"
        :src="info.showChildren?nav_arrow_down:nav_arrow_right"
        class="arrow"
      />
    </div>
    <transition>
      <div v-if="info.showChildren">
        <NavCell
          child
          v-for="childInfo in info.children"
          :key="childInfo.name"
          :info="childInfo"
          @clickChildren="clickChildren"
        />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
$mainPurple: #00c1de;
$mainBlue: #00c1de;

.cell {
  display: flex;
  align-items: center;
  height: 38px;
  margin-bottom: 6px;
  cursor: pointer;
  border-right: 3px solid #fff;
  background-color: #fff;
  color: #a2a4a6;
  user-select: none;

  .icon {
    margin-left: 15px;
    width: 18px;
    height: 18px;
    object-fit: contain;
    margin-right: 13px;
  }

  .galssLarge {
    width: 22px;
    height: 22px;
    margin-right: 10px;
    margin-left: 14px;
  }

  > p {
    flex-grow: 1;
  }

  .arrow {
    margin-right: 14px;
  }

  &:hover {
    color: $mainPurple;
  }
}

.cellSelected {
  border-color: $mainPurple;
  color: $mainPurple;
  background-color: #edf7fa;
}

.cellShowChildren {
  color: $mainPurple;
}
.versionBox {
  margin-left: 9px;
  width:42px;
  height:22px;
  background:rgba(229,252,255,1);
  border-radius:4px;
  border:1px solid rgba(0,193,222,1);
  text-align: center;
  font-size:12px;
  font-weight:400;
  color:rgba(0,193,222,1);
  line-height:22px;
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/NavCell.vue